import { createTheme } from '@mantine/core';

// VoyLogic Branding Theme
// Primary color palette (order matters):
// - Purple: #48367a
// - Cerise: #cc1d52
// - Orange: #f67538
// - Sand:   #f5b03f
// Secondary color palette (order matters):
// - Muted Purple: #6d5e95
// - Cream:        #fcf0d9
// - Deep Cerise : #811d52

export const theme = createTheme({
  primaryColor: 'voyPurple',
  primaryShade: 6,
  fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
  defaultRadius: 'md',
  colors: {
    // Primary: Purple (#48367a)
    voyPurple: [
      '#f1eef8',
      '#e2dbf1',
      '#c2b6e3',
      '#a091d4',
      '#7f6cc6',
      '#6453ad',
      '#48367a', // primary
      '#3f306e',
      '#362a60',
      '#2b234d',
    ],
    // Primary: Cerise (#cc1d52)
    voyCerise: [
      '#ffe9ef',
      '#ffd2dd',
      '#ffa9bd',
      '#f67895',
      '#e45071',
      '#d4365f',
      '#cc1d52',
      '#af1746',
      '#8f133b',
      '#6b0d2d',
    ],
    // Primary: Orange (#f67538)
    voyOrange: [
      '#fff2e9',
      '#ffe4d3',
      '#ffc6a9',
      '#ffa176',
      '#ff8a55',
      '#f7723c',
      '#f67538', // primary
      '#e56730',
      '#c95729',
      '#a44421',
    ],
    // Primary: Sand (#f5b03f)
    voySand: [
      '#fff6e8',
      '#feeccf',
      '#fbdca3',
      '#f6cc79',
      '#f3bf57',
      '#f1b447',
      '#f5b03f', // primary
      '#d99a37',
      '#bb8530',
      '#966a26',
    ],
    // Secondary: Muted Purple (#6d5e95)
    voyMutedPurple: [
      '#f3f1f8',
      '#e5e0f0',
      '#cfc4e0',
      '#b7a8d0',
      '#9f8cc0',
      '#8771af',
      '#6d5e95', // primary
      '#5f527f',
      '#4f466b',
      '#3d3552',
    ],
    // Secondary: Cream centered on #fcf0d9
    voyCream: [
      '#ffffff',
      '#fffdf6',
      '#fff8ea',
      '#fff3de',
      '#feeed1',
      '#fee7c1',
      '#fcf0d9',
      '#f1e2c1',
      '#e6d4ab',
      '#c9b88e',
    ],
    // Secondary: Deep Cerise (#811d52)
    voyCeriseDeep: [
      '#f6e9ef',
      '#f0d3dd',
      '#e5aabc',
      '#d8799a',
      '#c9537e',
      '#b9396c',
      '#811d52', // primary
      '#6f1745',
      '#581337',
      '#400d28',
    ],
    // Alias palette: for the TitleBox background
    // var(--mantine-color-voyTitleBox-6)
    voyTitleBox: [
      'var(--mantine-color-voySand-0)',
      'var(--mantine-color-voySand-1)',
      'var(--mantine-color-voySand-2)',
      'var(--mantine-color-voySand-3)',
      'var(--mantine-color-voySand-4)',
      'var(--mantine-color-voySand-5)',
      'var(--mantine-color-voySand-6)',
      'var(--mantine-color-voySand-7)',
      'var(--mantine-color-voySand-8)',
      'var(--mantine-color-voySand-9)',
    ],
  },
  other: {},
  headings: {
    fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    fontWeight: '700',
  },
  components: {
    Button: {
      defaultProps: {
        radius: 'md',
        color: 'var(--mantine-color-voyPurple-5)',
      },
    },
    ActionIcon: {
      defaultProps: {
        radius: 'md',
      },
    },
    Anchor: {
      defaultProps: {
        c: 'voyCerise.6',
      },
    },
  },
});
